/**
 * kisiFirmaIsverenService.js — bir kişiyi BİR firmada İşveren olarak işaretle / işareti kaldır.
 * Backlog #365 + #370 (backend #369, 2026-10-13; #299'un yerini alır, o uç hiç yapılmadı).
 *
 * İşveren artık KİŞİ × FİRMA bayrağıdır (`person_firma_isveren`): Hasan Kaya Dekor'un işverenidir, onu işe alan her
 * firmanın değil. Personel (staff) herhangi bir firmada işaretleyebilir — kişinin o firmada görevlendirmesi ya da
 * personel listesi kaydı olması ŞART DEĞİL. Kart kararı bir sonraki okumada buna göre yenilenir (firmalar arası
 * işveren esnekliği dahil); basılmış kartlara dokunulmaz.
 *
 * PATCH /api/v1/personnel/{personId}/firmalar/{firmaId}/isveren   { isveren: true | false }   (yalnızca staff)
 *   · Zaten o değerdeyse 200 ve `degisti: false` (işaretsiz firmada kaldırma da).
 *   · 400 `isveren` yok / boolean değil · 404 kişi ya da firma yok · 409 `BIRLESTIRILMIS_KART` (birleştirilmiş kart).
 *   · `data` = { personId, firmaId, firmaName, isveren, degisti, kaynak (1 Eski kayıt / 2 SAKA personeli), kaynakAdi,
 *               isverenDegisikligi { tarih, degistirenUserId, degistirenAdi, isveren }, isverenFirmalar[] }.
 */
import axios from "axios";
import { JAVA_BACKEND_API_URL, getAuthHeader } from "../Components/Contexts/BackendConstants";

const BASE = `${JAVA_BACKEND_API_URL}/personnel`;

/**
 * Backend hata gövdesi bazen düz metin, bazen `{ message, result, data }` zarfı. Fırlatılan Error `.status` taşır;
 * 400/409'da gövdenin `data`sı (örn. `{ kod: "BIRLESTIRILMIS_KART", ... }`) `.kod` ve `.data` olarak kopyalanır.
 */
function parseError(error) {
  const govde = error.response?.data;
  const message = typeof govde === "string"
    ? govde
    : govde?.message ?? error.message ?? "Bilinmeyen hata";
  const wrapped = new Error(message);
  wrapped.status = error.response?.status ?? null;
  const ayrinti = govde && typeof govde === "object" ? govde.data : null;
  if ((wrapped.status === 409 || wrapped.status === 400) && ayrinti && typeof ayrinti === "object") {
    wrapped.kod = ayrinti.kod ?? null;
    wrapped.data = ayrinti;
  }
  throw wrapped;
}

/**
 * @param {number|string} personId
 * @param {number|string} firmaId
 * @param {boolean}       isveren  true = işaretle, false = işareti kaldır
 * @returns {Promise<object>} zarfın `data`sı (yukarıdaki şekil); `degisti: false` = zaten o değerdeydi
 */
export async function setKisiFirmaIsveren(personId, firmaId, isveren) {
  try {
    const response = await axios.patch(
      `${BASE}/${personId}/firmalar/${firmaId}/isveren`,
      { isveren: Boolean(isveren) },
      { headers: getAuthHeader() },
    );
    return response.data?.data ?? null;
  } catch (error) {
    parseError(error);
  }
}
